const GET_ARTICLES_DETAIL_LOADING = 'GET_ARTICLES_DETAIL_LOADING'
const GET_ARTICLES_DETAIL_SUCCESS = 'GET_ARTICLES_DETAIL_SUCCESS'
const GET_ARTICLES_DETAIL_ERROR = 'GET_ARTICLES_DETAIL_ERROR'

const GET_ARTICLES_LIST_LOADING = 'GET_ARTICLES_LIST_LOADING'
const GET_ARTICLES_LIST_SUCCESS = 'GET_ARTICLES_LIST_SUCCESS'
const GET_ARTICLES_LIST_ERROR = 'GET_ARTICLES_LIST_ERROR'

const GET_NEXT_ARTICLES_LIST_SUCCESS = 'GET_NEXT_ARTICLES_LIST_SUCCESS'

export {
  GET_ARTICLES_DETAIL_LOADING,
  GET_ARTICLES_DETAIL_SUCCESS,
  GET_ARTICLES_DETAIL_ERROR,
  GET_ARTICLES_LIST_LOADING,
  GET_ARTICLES_LIST_SUCCESS,
  GET_ARTICLES_LIST_ERROR,
  GET_NEXT_ARTICLES_LIST_SUCCESS,
}